// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Toggle Switch Styles */
.Branding_previewHeader__\\+hmj2 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  flex-wrap: wrap;
  gap: 12px;
}

.Branding_toggleSwitch__WyzpC {
  position: relative;
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  gap: 10px;
}

.Branding_toggleSwitch__WyzpC input {
  opacity: 0;
  width: 0;
  height: 0;
  position: absolute;
}

.Branding_toggleSlider__JtvA9 {
  position: relative;
  display: inline-block;
  width: 44px;
  height: 24px;
  background-color: #ccc;
  border-radius: 24px;
  transition: 0.3s;
}

.Branding_toggleSlider__JtvA9:before {
  position: absolute;
  content: "";
  height: 18px;
  width: 18px;
  left: 3px;
  bottom: 3px;
  background-color: white;
  border-radius: 50%;
  transition: 0.3s;
}

.Branding_toggleSwitch__WyzpC input:checked + .Branding_toggleSlider__JtvA9 {
  background-color: #0084ff;
}

.Branding_toggleSwitch__WyzpC input:checked + .Branding_toggleSlider__JtvA9:before {
  transform: translateX(20px);
}

.Branding_toggleLabel__c5qfO {
  font-size: 13px;
  color: #65676b;
  -webkit-user-select: none;
          user-select: none;
}

/* No Access / Upgrade Styles */
.Branding_noAccessContainer__9M0vS {
  max-width: 800px;
  margin: 0 auto;
  padding: 48px 24px;
}

.Branding_noAccessCard__xedqd {
  background: #ffffff;
  border-radius: 16px;
  padding: 48px 32px;
  text-align: center;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  border: 1px solid #e4e6eb;
}

.Branding_noAccessIcon__v8PyF {
  font-size: 64px;
  margin-bottom: 24px;
}

.Branding_noAccessTitle__A9iPa {
  font-size: 24px;
  font-weight: 600;
  color: #1a1a1a;
  margin-bottom: 16px;
}

.Branding_noAccessMessage__M8wtA {
  font-size: 16px;
  color: #65676b;
  margin-bottom: 12px;
  line-height: 1.5;
}

.Branding_noAccessSubmessage__-HSDk {
  font-size: 14px;
  color: #8f9296;
  margin-bottom: 32px;
}

.Branding_upgradeButton__pld85 {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  padding: 12px 32px;
  font-size: 16px;
  font-weight: 500;
  border-radius: 8px;
  cursor: pointer;
  transition: transform 0.2s, box-shadow 0.2s;
}

.Branding_upgradeButton__pld85:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
}

.Branding_upgradeButton__pld85:active {
  transform: translateY(0);
}

/* Magic Chat Link Styles */
.Branding_magicChatLink__R6wrR {
  color: #0084ff;
  text-decoration: none;
  font-weight: 500;
  transition: color 0.2s ease;
}

.Branding_magicChatLink__R6wrR:hover {
  color: #0073e6;
  text-decoration: underline;
}

.Branding_magicChatLink__R6wrR:visited {
  color: #0084ff;
}

.Branding_magicChatLink__R6wrR:active {
  color: #005bb5;
}

/* Responsive adjustments */
@media (max-width: 640px) {
  .Branding_previewHeader__\\+hmj2 {
    flex-direction: column;
    align-items: flex-start;
  }
  
  .Branding_noAccessCard__xedqd {
    padding: 32px 20px;
  }
  
  .Branding_noAccessTitle__A9iPa {
    font-size: 20px;
  }
  
  .Branding_upgradeButton__pld85 {
    width: 100%;
  }
}

/* Replace the preview section styles with these */
/* Add to your existing CSS file */

.Branding_magicChatLink__R6wrR {
  color: #0084ff;
  text-decoration: none;
  font-weight: 500;
  transition: color 0.2s ease;
}

.Branding_magicChatLink__R6wrR:hover {
  color: #0073e6;
  text-decoration: underline;
}

.Branding_magicChatLink__R6wrR:visited {
  color: #0084ff;
}

.Branding_magicChatLink__R6wrR:active {
  color: #005bb5;
}


.Branding_previewSection__baYcY {
  background: #f0f2f5;
  padding: 20px;
  border-radius: 12px;
}

.Branding_previewSection__baYcY .Branding_sectionTitle__RUCFT {
  color: #1a1a1a;
  margin-bottom: 16px;
  font-size: 18px;
}

/* Real Chat Preview Styles */
.Branding_realChatPreview__poG\\+G {
  background: white;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  height: 500px;
}

/* Chat Header */
.Branding_chatHeader__vc2jD {
  background: #ffffff;
  border-bottom: 1px solid #e4e6eb;
  padding: 12px 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.Branding_chatHeaderInfo__12-nY {
  display: flex;
  align-items: center;
  gap: 12px;
}

.Branding_botAvatarLarge__ESsth {
  width: 40px;
  height: 40px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
}

.Branding_chatHeaderText__R05aU {
  display: flex;
  flex-direction: column;
}

.Branding_chatBotName__vAXwm {
  font-weight: 600;
  font-size: 16px;
  color: #050505;
}

.Branding_chatStatus__Xz5qx {
  font-size: 12px;
  color: #31a24c;
}

.Branding_iconButton__pG8Cg {
  background: none;
  border: none;
  font-size: 20px;
  cursor: pointer;
  color: #65676b;
  padding: 8px;
  border-radius: 50%;
  transition: background 0.2s;
}

.Branding_iconButton__pG8Cg:hover {
  background: #f0f2f5;
}

/* Chat Messages Area */
.Branding_chatMessages__ieGt- {
  flex: 1 1;
  overflow-y: auto;
  padding: 16px;
  background: #f0f2f5;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.Branding_messageGroup__eJbbc {
  display: flex;
  flex-direction: column;
}

/* Bot Message Styles */
.Branding_botMessageBubble__bwHf5 {
  align-self: flex-start;
  max-width: 70%;
}

.Branding_botMessageContent__XzizA {
  background: #ffffff;
  color: #050505;
  padding: 10px 14px;
  border-radius: 18px;
  border-bottom-left-radius: 4px;
  font-size: 14px;
  line-height: 1.4;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);
}

/* User Message Styles */
.Branding_userMessageBubble__fiVsG {
  align-self: flex-end;
  max-width: 70%;
}

.Branding_userMessageContent__OtaaU {
  background: #0084ff;
  color: white;
  padding: 10px 14px;
  border-radius: 18px;
  border-bottom-right-radius: 4px;
  font-size: 14px;
  line-height: 1.4;
}

.Branding_messageTime__S\\+s2I {
  font-size: 10px;
  color: #65676b;
  margin-top: 4px;
  margin-left: 12px;
  margin-right: 12px;
}

.Branding_userMessageBubble__fiVsG .Branding_messageTime__S\\+s2I {
  text-align: right;
}

/* Chat Input Area */
.Branding_chatInput__1OyHf {
  border-top: 1px solid #e4e6eb;
  padding: 12px 16px;
  background: white;
  display: flex;
  gap: 8px;
  align-items: center;
}

.Branding_chatInputField__zFisO {
  flex: 1 1;
  padding: 10px 14px;
  border: 1px solid #e4e6eb;
  border-radius: 20px;
  font-size: 14px;
  outline: none;
  transition: border-color 0.2s;
  background: #f0f2f5;
}

.Branding_chatInputField__zFisO:focus {
  border-color: #0084ff;
  background: white;
}

.Branding_sendButton__EP-\\+q {
  background: #0084ff;
  border: none;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.2s;
  color: white;
}

.Branding_sendButton__EP-\\+q:hover {
  background: #0073e6;
}

/* Chat Footer */
.Branding_chatFooter__Ne9pT {
  text-align: center;
  padding: 12px;
  font-size: 11px;
  color: #65676b;
  border-top: 1px solid #e4e6eb;
  background: white;
}

/* Scrollbar Styling */
.Branding_chatMessages__ieGt-::-webkit-scrollbar {
  width: 6px;
}

.Branding_chatMessages__ieGt-::-webkit-scrollbar-track {
  background: #f0f2f5;
}

.Branding_chatMessages__ieGt-::-webkit-scrollbar-thumb {
  background: #bcc0c4;
  border-radius: 3px;
}

.Branding_chatMessages__ieGt-::-webkit-scrollbar-thumb:hover {
  background: #8f9296;
}

/* Responsive */
@media (max-width: 640px) {
  .Branding_realChatPreview__poG\\+G {
    height: 400px;
  }
  
  .Branding_botMessageBubble__bwHf5, .Branding_userMessageBubble__fiVsG {
    max-width: 85%;
  }
}`, "",{"version":3,"sources":["webpack://./src/Component/SideData/Overview/Branding/Branding.module.css"],"names":[],"mappings":"AAAA,yBAAyB;AACzB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA,+BAA+B;AAC/B;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,yCAAyC;EACzC,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,2CAA2C;AAC7C;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,2BAA2B;AAC3B;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,2BAA2B;AAC3B;EACE;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;AACF;;AAEA,kDAAkD;AAClD,kCAAkC;;AAElC;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;;AAGA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;AACjB;;AAEA,6BAA6B;AAC7B;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,wCAAwC;EACxC,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;;AAEA,gBAAgB;AAChB;EACE,mBAAmB;EACnB,gCAAgC;EAChC,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,6DAA6D;EAC7D,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA,uBAAuB;AACvB;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA,uBAAuB;AACvB;EACE,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA,wBAAwB;AACxB;EACE,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,oBAAoB;AACpB;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,2BAA2B;EAC3B,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,cAAc;EACd,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA,sBAAsB;AACtB;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;AACF","sourcesContent":["/* Toggle Switch Styles */\n.previewHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 16px;\n  flex-wrap: wrap;\n  gap: 12px;\n}\n\n.toggleSwitch {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  cursor: pointer;\n  gap: 10px;\n}\n\n.toggleSwitch input {\n  opacity: 0;\n  width: 0;\n  height: 0;\n  position: absolute;\n}\n\n.toggleSlider {\n  position: relative;\n  display: inline-block;\n  width: 44px;\n  height: 24px;\n  background-color: #ccc;\n  border-radius: 24px;\n  transition: 0.3s;\n}\n\n.toggleSlider:before {\n  position: absolute;\n  content: \"\";\n  height: 18px;\n  width: 18px;\n  left: 3px;\n  bottom: 3px;\n  background-color: white;\n  border-radius: 50%;\n  transition: 0.3s;\n}\n\n.toggleSwitch input:checked + .toggleSlider {\n  background-color: #0084ff;\n}\n\n.toggleSwitch input:checked + .toggleSlider:before {\n  transform: translateX(20px);\n}\n\n.toggleLabel {\n  font-size: 13px;\n  color: #65676b;\n  user-select: none;\n}\n\n/* No Access / Upgrade Styles */\n.noAccessContainer {\n  max-width: 800px;\n  margin: 0 auto;\n  padding: 48px 24px;\n}\n\n.noAccessCard {\n  background: #ffffff;\n  border-radius: 16px;\n  padding: 48px 32px;\n  text-align: center;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n  border: 1px solid #e4e6eb;\n}\n\n.noAccessIcon {\n  font-size: 64px;\n  margin-bottom: 24px;\n}\n\n.noAccessTitle {\n  font-size: 24px;\n  font-weight: 600;\n  color: #1a1a1a;\n  margin-bottom: 16px;\n}\n\n.noAccessMessage {\n  font-size: 16px;\n  color: #65676b;\n  margin-bottom: 12px;\n  line-height: 1.5;\n}\n\n.noAccessSubmessage {\n  font-size: 14px;\n  color: #8f9296;\n  margin-bottom: 32px;\n}\n\n.upgradeButton {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  border: none;\n  padding: 12px 32px;\n  font-size: 16px;\n  font-weight: 500;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: transform 0.2s, box-shadow 0.2s;\n}\n\n.upgradeButton:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);\n}\n\n.upgradeButton:active {\n  transform: translateY(0);\n}\n\n/* Magic Chat Link Styles */\n.magicChatLink {\n  color: #0084ff;\n  text-decoration: none;\n  font-weight: 500;\n  transition: color 0.2s ease;\n}\n\n.magicChatLink:hover {\n  color: #0073e6;\n  text-decoration: underline;\n}\n\n.magicChatLink:visited {\n  color: #0084ff;\n}\n\n.magicChatLink:active {\n  color: #005bb5;\n}\n\n/* Responsive adjustments */\n@media (max-width: 640px) {\n  .previewHeader {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n  \n  .noAccessCard {\n    padding: 32px 20px;\n  }\n  \n  .noAccessTitle {\n    font-size: 20px;\n  }\n  \n  .upgradeButton {\n    width: 100%;\n  }\n}\n\n/* Replace the preview section styles with these */\n/* Add to your existing CSS file */\n\n.magicChatLink {\n  color: #0084ff;\n  text-decoration: none;\n  font-weight: 500;\n  transition: color 0.2s ease;\n}\n\n.magicChatLink:hover {\n  color: #0073e6;\n  text-decoration: underline;\n}\n\n.magicChatLink:visited {\n  color: #0084ff;\n}\n\n.magicChatLink:active {\n  color: #005bb5;\n}\n\n\n.previewSection {\n  background: #f0f2f5;\n  padding: 20px;\n  border-radius: 12px;\n}\n\n.previewSection .sectionTitle {\n  color: #1a1a1a;\n  margin-bottom: 16px;\n  font-size: 18px;\n}\n\n/* Real Chat Preview Styles */\n.realChatPreview {\n  background: white;\n  border-radius: 12px;\n  overflow: hidden;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  display: flex;\n  flex-direction: column;\n  height: 500px;\n}\n\n/* Chat Header */\n.chatHeader {\n  background: #ffffff;\n  border-bottom: 1px solid #e4e6eb;\n  padding: 12px 16px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.chatHeaderInfo {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.botAvatarLarge {\n  width: 40px;\n  height: 40px;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: white;\n}\n\n.chatHeaderText {\n  display: flex;\n  flex-direction: column;\n}\n\n.chatBotName {\n  font-weight: 600;\n  font-size: 16px;\n  color: #050505;\n}\n\n.chatStatus {\n  font-size: 12px;\n  color: #31a24c;\n}\n\n.iconButton {\n  background: none;\n  border: none;\n  font-size: 20px;\n  cursor: pointer;\n  color: #65676b;\n  padding: 8px;\n  border-radius: 50%;\n  transition: background 0.2s;\n}\n\n.iconButton:hover {\n  background: #f0f2f5;\n}\n\n/* Chat Messages Area */\n.chatMessages {\n  flex: 1;\n  overflow-y: auto;\n  padding: 16px;\n  background: #f0f2f5;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.messageGroup {\n  display: flex;\n  flex-direction: column;\n}\n\n/* Bot Message Styles */\n.botMessageBubble {\n  align-self: flex-start;\n  max-width: 70%;\n}\n\n.botMessageContent {\n  background: #ffffff;\n  color: #050505;\n  padding: 10px 14px;\n  border-radius: 18px;\n  border-bottom-left-radius: 4px;\n  font-size: 14px;\n  line-height: 1.4;\n  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);\n}\n\n/* User Message Styles */\n.userMessageBubble {\n  align-self: flex-end;\n  max-width: 70%;\n}\n\n.userMessageContent {\n  background: #0084ff;\n  color: white;\n  padding: 10px 14px;\n  border-radius: 18px;\n  border-bottom-right-radius: 4px;\n  font-size: 14px;\n  line-height: 1.4;\n}\n\n.messageTime {\n  font-size: 10px;\n  color: #65676b;\n  margin-top: 4px;\n  margin-left: 12px;\n  margin-right: 12px;\n}\n\n.userMessageBubble .messageTime {\n  text-align: right;\n}\n\n/* Chat Input Area */\n.chatInput {\n  border-top: 1px solid #e4e6eb;\n  padding: 12px 16px;\n  background: white;\n  display: flex;\n  gap: 8px;\n  align-items: center;\n}\n\n.chatInputField {\n  flex: 1;\n  padding: 10px 14px;\n  border: 1px solid #e4e6eb;\n  border-radius: 20px;\n  font-size: 14px;\n  outline: none;\n  transition: border-color 0.2s;\n  background: #f0f2f5;\n}\n\n.chatInputField:focus {\n  border-color: #0084ff;\n  background: white;\n}\n\n.sendButton {\n  background: #0084ff;\n  border: none;\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: background 0.2s;\n  color: white;\n}\n\n.sendButton:hover {\n  background: #0073e6;\n}\n\n/* Chat Footer */\n.chatFooter {\n  text-align: center;\n  padding: 12px;\n  font-size: 11px;\n  color: #65676b;\n  border-top: 1px solid #e4e6eb;\n  background: white;\n}\n\n/* Scrollbar Styling */\n.chatMessages::-webkit-scrollbar {\n  width: 6px;\n}\n\n.chatMessages::-webkit-scrollbar-track {\n  background: #f0f2f5;\n}\n\n.chatMessages::-webkit-scrollbar-thumb {\n  background: #bcc0c4;\n  border-radius: 3px;\n}\n\n.chatMessages::-webkit-scrollbar-thumb:hover {\n  background: #8f9296;\n}\n\n/* Responsive */\n@media (max-width: 640px) {\n  .realChatPreview {\n    height: 400px;\n  }\n  \n  .botMessageBubble, .userMessageBubble {\n    max-width: 85%;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"previewHeader": `Branding_previewHeader__+hmj2`,
	"toggleSwitch": `Branding_toggleSwitch__WyzpC`,
	"toggleSlider": `Branding_toggleSlider__JtvA9`,
	"toggleLabel": `Branding_toggleLabel__c5qfO`,
	"noAccessContainer": `Branding_noAccessContainer__9M0vS`,
	"noAccessCard": `Branding_noAccessCard__xedqd`,
	"noAccessIcon": `Branding_noAccessIcon__v8PyF`,
	"noAccessTitle": `Branding_noAccessTitle__A9iPa`,
	"noAccessMessage": `Branding_noAccessMessage__M8wtA`,
	"noAccessSubmessage": `Branding_noAccessSubmessage__-HSDk`,
	"upgradeButton": `Branding_upgradeButton__pld85`,
	"magicChatLink": `Branding_magicChatLink__R6wrR`,
	"previewSection": `Branding_previewSection__baYcY`,
	"sectionTitle": `Branding_sectionTitle__RUCFT`,
	"realChatPreview": `Branding_realChatPreview__poG+G`,
	"chatHeader": `Branding_chatHeader__vc2jD`,
	"chatHeaderInfo": `Branding_chatHeaderInfo__12-nY`,
	"botAvatarLarge": `Branding_botAvatarLarge__ESsth`,
	"chatHeaderText": `Branding_chatHeaderText__R05aU`,
	"chatBotName": `Branding_chatBotName__vAXwm`,
	"chatStatus": `Branding_chatStatus__Xz5qx`,
	"iconButton": `Branding_iconButton__pG8Cg`,
	"chatMessages": `Branding_chatMessages__ieGt-`,
	"messageGroup": `Branding_messageGroup__eJbbc`,
	"botMessageBubble": `Branding_botMessageBubble__bwHf5`,
	"botMessageContent": `Branding_botMessageContent__XzizA`,
	"userMessageBubble": `Branding_userMessageBubble__fiVsG`,
	"userMessageContent": `Branding_userMessageContent__OtaaU`,
	"messageTime": `Branding_messageTime__S+s2I`,
	"chatInput": `Branding_chatInput__1OyHf`,
	"chatInputField": `Branding_chatInputField__zFisO`,
	"sendButton": `Branding_sendButton__EP-+q`,
	"chatFooter": `Branding_chatFooter__Ne9pT`
};
export default ___CSS_LOADER_EXPORT___;
